import React, { useState, useEffect, useRef } from "react";
import { get, post } from "../../services/api";

const StudentAcceptance = () => {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const centerId = localStorage.getItem("centerId");
  const roleId = localStorage.getItem("roleId");

  const [classesData, setClassesData] = useState([]);
  const [registrationsData, setRegistrationsData] = useState([]);

  useEffect(() => {
    const fetchClassesByCenterId = async () => {
      try {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };

    fetchClassesByCenterId();
  }, []);

  const getRegistrationsList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Student/GetPupilsInformationByUserId?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRegistrationsData(response);
    } catch (error) {
      console.error("Error fetching Centers:", error);
    }
  };

  useEffect(() => {
    getRegistrationsList();
  }, [organizationId, centerId]);

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Acceptance Status</h2>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row g-3">
            {registrationsData.map((item) => {
              const selectedClass = classesData.find(
                (classItem) => classItem.id === item.centerClassId
              );

              return (
                <div className="col-md-4" key={item.id}>
                  <div className="card h-100">
                    <div className="card-header fs-8 p-3 py-2 bg-light fw-bold">
                      {`${item.firstName} ${item.lastName}`}
                    </div>
                    <div className="fs-9 p-3">
                      <div>
                        <strong>Class:</strong> {selectedClass?.name || "N/A"}
                      </div>
                      <div>
                        <strong>Accepted:</strong>{" "}
                        {item.isAccepted ? "Yes" : "No"}
                      </div>

                      {item.isAccepted && (
                        <div>
                          <strong>Acceptance Remarks:</strong>{" "}
                          {item.acceptanceRemarks || "N/A"}
                        </div>
                      )}

                      {item.hasObservation && (
                        <>
                          <div>
                            <strong>Observation Status:</strong> Under
                            Observation
                          </div>
                          <div>
                            <strong>Observation Remarks:</strong>{" "}
                            {item.observationRemarks || "N/A"}
                          </div>
                        </>
                      )}

                      {item.shouldRetakeExam && (
                        <>
                          <div>
                            <strong>Retake Assessment:</strong> Yes
                          </div>
                          <div>
                            <strong>Retake Exam Remarks:</strong>{" "}
                            {item.retakeExamRemarks || "N/A"}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentAcceptance;
